import {
    Container,
    InnerContainer,
    InvitationBadge,
    InvitationItem,
    InvitationStatus,
    Text,
    EmailText,
} from "app/pages/digital-suite/home-page/components/Rewards/screens/InvitationStatusScreen/InvitationsList/InvitationsList.styled";
import { getBadgeInitials } from "app/pages/digital-suite/home-page/components/Rewards/screens/InvitationStatusScreen/InvitationsList/getBadgeInitials";
import type { IInvitation } from "app/pages/digital-suite/home-page/components/Rewards/utils/types";
import { i18nFilter } from "app/filters/i18nFilter";

const MS_PER_DAY = 1000 * 60 * 60 * 24;

interface IInvitationsListProps {
    invitationsList: IInvitation[];
}

const InvitationsList = ({ invitationsList }: IInvitationsListProps) => {
    const i18n = i18nFilter();

    const getDaysSinceInvited = (createdDate: string) => {
        const createdAtDate = new Date(createdDate);
        const today = new Date();

        const differenceInMs = today.getTime() - createdAtDate.getTime();
        return Math.floor(differenceInMs / MS_PER_DAY);
    };

    return (
        <Container>
            {invitationsList.map(({ Email: email, Status: status, CreatedAt: createdDate }) => (
                <InvitationItem key={email}>
                    <InvitationBadge>{getBadgeInitials(email)}</InvitationBadge>
                    <InnerContainer>
                        <EmailText>{email}</EmailText>
                        <Text>
                            {i18n("rewards_modal.invitation_screen.sent_date", {
                                days: getDaysSinceInvited(createdDate),
                            })}
                        </Text>
                    </InnerContainer>
                    <InvitationStatus isActive={status === "active"}>{status}</InvitationStatus>
                </InvitationItem>
            ))}
        </Container>
    );
};

export default InvitationsList;
